import { FC, useMemo } from 'react';
import cx from 'classnames';
import dayjs from 'dayjs';
import Image from "next/legacy/image";
import { DEFAULT_BLUR_IMAGE_DATA_URL } from 'constants/blurImage';
import { BlogPost } from 'constants/notionDataPages';

export interface ListingArticleBoxProps {
  post: BlogPost;
  reverse: boolean;
  preload: boolean;
  index: number;
}
const ListingArticleBox: FC<ListingArticleBoxProps> = ({
  post,
  reverse,
  preload,
  index
}) => {
  const visibleDate = useMemo(
    () => post.publishDate && post.publishDate.start && dayjs(post.publishDate.start).format('dddd, D MMMM YYYY'),
    [post.publishDate]
  );

  return (
    <div className="group reverse grid cursor-pointer gap-[10px] md:grid-cols-2 md:gap-[45px] ">
      <div
        className={cx(
          'overflow-hidden rounded-[6px] transition-opacity duration-[400ms] md:group-hover:opacity-50',
          {
            'md:order-last': reverse
          }
        )}>
        <div className={`relative max-h-[380px] ${index === 0 ? 'blog-image' : ''}`}>
          {post.cover ? (<Image
            width="508"
            height="380"
            layout="responsive"
            objectFit="cover"
            sizes="(min-width: 1024px) calc(40vw - 32px),
            (min-width: 640px) calc(70vw - 32px),
            calc(50vw - 32px)"
            src={post.cover.url!}
            alt={post.title + ' cover photo'}
            placeholder={'blur'}
            priority={preload}
            blurDataURL={post.cover.hash ? post.cover.hash : DEFAULT_BLUR_IMAGE_DATA_URL}
          />):'' }
        </div>
      </div>
      <div className="text-brand-black1000 flex h-full flex-col">
        <h3 className="text-[24px] font-medium uppercase tracking-[2px] transition-all duration-[400ms] md:group-hover:text-brand-orange md:group-hover:underline">
          {post.title}
        </h3>
        <div className="flex flex-auto flex-col justify-between">
          <div className="mt-[24px] tracking-[1px] text-brand-grey25">
            <div
              dangerouslySetInnerHTML={{
                __html: post.summary!
              }}
            />
            <span className="mt-[24px] block text-right font-medium tracking-[1px] text-brand-black100 transition-all md:text-left md:group-hover:text-brand-orange md:group-hover:underline">
              Read More
            </span>
          </div>
          <span className="text-medium text-right tracking-[1px] text-brand-grey300 md:text-left">
            {visibleDate}
          </span>
        </div>
      </div>
    </div>
  );
};

export default ListingArticleBox;
